import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { fetchInfo } from '../async-thunks/info/fetchInfo'

export interface IInfo {
    app_version?: string
    supported_api_version?: string[]
    supported_socket_versions?: string[]
    socket_address?: string
    backend_version?: string
    socket_version?: string
    websocket_path?: string
}

interface IInitialInfoState {
    info: IInfo
    isLoading: boolean
    error: string | null
}

const initialState: IInitialInfoState = {
    info: {},
    isLoading: false,
    error: null,
}

const infoSlice = createSlice({
    name: 'infoSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchInfo.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchInfo.fulfilled, (state, action: PayloadAction<IInfo>) => {
                state.info = action.payload
                state.isLoading = false
            })
            .addCase(fetchInfo.rejected, (state) => {
                state.isLoading = false
                state.error = 'Fetch info failed'
            })
    }
})

export const { reducer: infoReducer } = infoSlice
